import { render, staticRenderFns } from "./DetailStoreGiftListCategoryComponent.vue?vue&type=template&id=ca104fd0&scoped=true"
import script from "./DetailStoreGiftListCategoryComponent.vue?vue&type=script&lang=js"
export * from "./DetailStoreGiftListCategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailStoreGiftListCategoryComponent.vue?vue&type=style&index=0&id=ca104fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca104fd0",
  null
  
)

export default component.exports